/* VIBY homepage sections — shared behaviour.
   Loaded by every viby-* section; the guard below makes it run once.
   Clicks use event delegation, so sections re-rendered in the theme
   editor keep working without re-binding. */
(function () {
  if (window.__viby) return;
  window.__viby = true;

  var d = document;
  var mqDesk = window.matchMedia('(min-width: 900px)');

  /* ---------- helpers ---------- */
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }
  function lock(on) { d.documentElement.classList.toggle('vb-lock', !!on); }

  /* ---------- announcement rotation ---------- */
  var annTimers = new WeakMap();
  function annShow(root, dir) {
    var msgs = root.querySelectorAll('.vb-ann__msg');
    if (msgs.length < 2) return;
    var i = 0;
    msgs.forEach(function (m, k) { if (m.classList.contains('is-active')) i = k; });
    msgs[i].classList.remove('is-active');
    msgs[i].setAttribute('aria-hidden', 'true');
    i = (i + dir + msgs.length) % msgs.length;
    msgs[i].classList.add('is-active');
    msgs[i].removeAttribute('aria-hidden');
  }
  function annInit(root) {
    if (annTimers.has(root)) clearInterval(annTimers.get(root));
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 0;
    if (!speed || root.querySelectorAll('.vb-ann__msg').length < 2) return;
    var t = setInterval(function () { if (!root.matches(':hover')) annShow(root, 1); }, speed * 1000);
    annTimers.set(root, t);
  }

  /* ---------- header: hide on scroll down, show on scroll up ---------- */
  var lastY = window.scrollY;
  function onScroll() {
    var y = window.scrollY;
    d.querySelectorAll('[data-vb-header]').forEach(function (h) {
      var wrap = closest(h, '.shopify-section') || h;
      h.classList.toggle('is-stuck', y > 10);
      var drawerOpen = d.querySelector('.vb-drawer.is-open');
      var hide = h.getAttribute('data-hide-on-scroll') === 'true' && y > lastY && y > 200 && !drawerOpen && !h.querySelector('.vb-search:not([hidden])');
      if (hide) wrap.style.setProperty('--vb-hh', wrap.getBoundingClientRect().height + 'px');
      wrap.classList.toggle('is-hidden', hide);
    });
    lastY = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  function stickyCta() {
    var y = window.scrollY;
    d.querySelectorAll('[data-vb-sticky-cta]').forEach(function (b) {
      b.classList.toggle('is-on', y > (+b.getAttribute('data-after') || 0));
    });
  }
  window.addEventListener('scroll', stickyCta, { passive: true });

  /* ---------- drawer ---------- */
  var lastFocus = null;
  function drawer(id, open) {
    var dr = d.getElementById(id);
    if (!dr) return;
    var scrim = d.querySelector('[data-vb-scrim="' + id + '"]');
    dr.classList.toggle('is-open', open);
    dr.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (scrim) scrim.classList.toggle('is-open', open);
    d.querySelectorAll('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    lock(open);
    if (open) {
      lastFocus = d.activeElement;
      var c = dr.querySelector('.vb-drawer__close');
      if (c) setTimeout(function () { c.focus(); }, 50);
    } else if (lastFocus && lastFocus.focus) {
      lastFocus.focus();
    }
  }
  function closeAllDrawers() {
    d.querySelectorAll('.vb-drawer.is-open').forEach(function (dr) { drawer(dr.id, false); });
  }

  /* ---------- carousels ---------- */
  function carState(c) {
    var t = c.querySelector('[data-vb-track]');
    if (!t) return;
    var p = c.querySelector('[data-vb-prev]'), n = c.querySelector('[data-vb-next]');
    var scrollable = t.scrollWidth > t.clientWidth + 5;
    c.classList.toggle('is-scrollable', scrollable);
    if (p) p.disabled = t.scrollLeft < 5;
    if (n) n.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 5;
  }
  function carInit(c) {
    var t = c.querySelector('[data-vb-track]');
    if (!t || t.__vb) { carState(c); return; }
    t.__vb = true;
    t.addEventListener('scroll', function () { carState(c); }, { passive: true });
    carState(c);
  }
  function carStep(c, dir) {
    var t = c.querySelector('[data-vb-track]');
    if (!t || !t.firstElementChild) return;
    var gap = parseFloat(getComputedStyle(t).columnGap) || 10;
    t.scrollBy({ left: (t.firstElementChild.getBoundingClientRect().width + gap) * dir, behavior: 'smooth' });
  }
  window.addEventListener('resize', function () { d.querySelectorAll('[data-vb-carousel]').forEach(carState); });

  /* ---------- accordion ---------- */
  function qaToggle(item, force) {
    var list = closest(item, '[data-vb-accordion]');
    var open = typeof force === 'boolean' ? force : !item.classList.contains('is-open');
    if (open && list && list.getAttribute('data-single') === 'true') {
      list.querySelectorAll('.vb-qa.is-open').forEach(function (o) {
        if (o !== item) { o.classList.remove('is-open'); o.querySelector('.vb-qa__q').setAttribute('aria-expanded', 'false'); }
      });
    }
    item.classList.toggle('is-open', open);
    item.querySelector('.vb-qa__q').setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* ---------- video reels ---------- */
  function stopReel(r) {
    var v = r.querySelector('video');
    if (v) { v.pause(); }
    var f = r.querySelector('iframe[data-vb-embed]');
    if (f) f.remove();
    r.classList.remove('is-playing');
  }
  function playReel(r) {
    d.querySelectorAll('.vb-reel.is-playing').forEach(function (o) { if (o !== r) stopReel(o); });
    var v = r.querySelector('video');
    if (v) {
      v.muted = r.getAttribute('data-sound') !== 'true';
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
      r.classList.add('is-playing');
      updateMute(r);
      return;
    }
    var src = r.getAttribute('data-embed');
    if (src) {
      var f = d.createElement('iframe');
      f.setAttribute('data-vb-embed', '');
      f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      f.setAttribute('allowfullscreen', '');
      f.src = src;
      r.appendChild(f);
      r.classList.add('is-playing');
    }
  }
  function updateMute(r) {
    var v = r.querySelector('video'), b = r.querySelector('.vb-reel__mute');
    if (!v || !b) return;
    b.setAttribute('aria-label', v.muted ? 'Unmute video' : 'Mute video');
    b.innerHTML = v.muted
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 5L6 9H2v6h4l5 4z"/><path d="M23 9l-6 6M17 9l6 6"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 5L6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a10 10 0 0 1 0 14"/></svg>';
  }

  /* ---------- delegated clicks ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target, el;

    if ((el = closest(t, '[data-vb-cart-open]'))) { e.preventDefault(); VibyCart.open(); return; }
    if ((el = closest(t, '[data-vb-qty]'))) {
      var ln = closest(el, '.vb-cline'), q = +ln.querySelector('.vb-qty span').textContent + (+el.getAttribute('data-vb-qty'));
      VibyCart.change(ln.getAttribute('data-key'), Math.max(0, q)); return;
    }
    if ((el = closest(t, '[data-vb-remove]'))) { VibyCart.change(closest(el, '.vb-cline').getAttribute('data-key'), 0); return; }
    if ((el = closest(t, 'a[href="#buy"],[data-vb-scroll-buy]'))) {
      var bb = d.querySelector('[data-vb-buybox]');
      if (bb) {
        e.preventDefault();
        var hdr = d.querySelector('.vb-header-section'), off = hdr ? hdr.getBoundingClientRect().height : 0;
        window.scrollTo({ top: bb.getBoundingClientRect().top + window.scrollY - off - 12, behavior: 'smooth' });
      }
      return;
    }
    if ((el = closest(t, '[data-vb-drawer-open]'))) { e.preventDefault(); drawer(el.getAttribute('aria-controls'), true); return; }
    if ((el = closest(t, '[data-vb-drawer-close]')) || (el = closest(t, '[data-vb-scrim]'))) { closeAllDrawers(); return; }
    if (closest(t, '.vb-drawer a[href]') && !closest(t, 'summary')) { closeAllDrawers(); return; }

    if ((el = closest(t, '[data-vb-search-toggle]'))) {
      var box = d.getElementById(el.getAttribute('aria-controls'));
      if (box) {
        var willOpen = box.hasAttribute('hidden');
        if (willOpen) box.removeAttribute('hidden'); else box.setAttribute('hidden', '');
        el.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen) { var i = box.querySelector('input'); if (i) i.focus(); }
      }
      return;
    }

    if ((el = closest(t, '[data-vb-ann-prev]'))) { annShow(closest(el, '[data-vb-ann]'), -1); return; }
    if ((el = closest(t, '[data-vb-ann-next]'))) { annShow(closest(el, '[data-vb-ann]'), 1); return; }

    if ((el = closest(t, '[data-vb-prev]'))) { carStep(closest(el, '[data-vb-carousel]'), -1); return; }
    if ((el = closest(t, '[data-vb-next]'))) { carStep(closest(el, '[data-vb-carousel]'), 1); return; }

    if ((el = closest(t, '.vb-qa__q'))) { qaToggle(closest(el, '.vb-qa')); return; }

    if ((el = closest(t, '.vb-reel__mute'))) {
      var r0 = closest(el, '.vb-reel'), v0 = r0.querySelector('video');
      if (v0) { v0.muted = !v0.muted; updateMute(r0); }
      return;
    }
    if (closest(t, '.vb-reel__prod')) return; // let product link navigate
    if ((el = closest(t, '.vb-reel'))) {
      if (el.classList.contains('is-playing')) stopReel(el); else playReel(el);
    }
  });

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllDrawers();
      d.querySelectorAll('.vb-search:not([hidden])').forEach(function (s) { s.setAttribute('hidden', ''); });
    }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('vb-reel')) {
      e.preventDefault(); e.target.click();
    }
  });

  /* close drawer when switching to desktop inline nav */
  mqDesk.addEventListener && mqDesk.addEventListener('change', function (m) { if (m.matches) closeAllDrawers(); });


  /* ---------- countdown bar ---------- */
  var cdTimers = new WeakMap();
  function londonOffsetMin(dt) {
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', timeZoneName: 'short' }).formatToParts(dt);
      var tz = (p.find(function (x) { return x.type === 'timeZoneName'; }) || {}).value || '';
      return /BST|\+1/.test(tz) ? 60 : 0;
    } catch (e) { return 0; }
  }
  function londonSecondsToday() {
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      var g = function (t) { return +((p.find(function (x) { return x.type === t; }) || {}).value || 0); };
      return g('hour') * 3600 + g('minute') * 60 + g('second');
    } catch (e) { var n = new Date(); return n.getHours() * 3600 + n.getMinutes() * 60 + n.getSeconds(); }
  }
  function cdEnd(el, forceNew) {
    var mode = el.getAttribute('data-mode');
    var now = Date.now();
    if (mode === 'date') {
      var m = (el.getAttribute('data-end') || '').match(/(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
      if (!m) return 0;
      var utc = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59));
      return utc - londonOffsetMin(new Date(utc)) * 60000;
    }
    if (mode === 'midnight') return now + (86400 - londonSecondsToday()) * 1000;
    var dur = ((+el.getAttribute('data-hours') || 0) * 3600 + (+el.getAttribute('data-minutes') || 0) * 60) * 1000 || 7200000;
    var key = el.getAttribute('data-key');
    if (el.getAttribute('data-restart') === 'load' || forceNew) {
      var e0 = now + dur;
      try { localStorage.setItem(key, e0); } catch (e) {}
      return e0;
    }
    var stored = 0;
    try { stored = +localStorage.getItem(key) || 0; } catch (e) {}
    if (!stored || stored <= now || stored - now > dur) {
      stored = now + dur;
      try { localStorage.setItem(key, stored); } catch (e) {}
    }
    return stored;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function cdInit(el) {
    if (cdTimers.has(el)) clearInterval(cdTimers.get(el));
    var end = cdEnd(el);
    var hasDays = !!el.querySelector('[data-u="d"]');
    var tick = function () {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (left <= 0) {
        var mode = el.getAttribute('data-mode');
        if (mode === 'evergreen') { end = cdEnd(el, true); left = Math.floor((end - Date.now()) / 1000); }
        else if (mode === 'midnight') { end = cdEnd(el); left = Math.floor((end - Date.now()) / 1000); }
        else if (el.getAttribute('data-expired') === 'hide') { el.classList.add('is-expired'); clearInterval(cdTimers.get(el)); return; }
      }
      var dd = Math.floor(left / 86400), hh = Math.floor(left % 86400 / 3600), mm = Math.floor(left % 3600 / 60), ss = left % 60;
      if (!hasDays) hh += dd * 24;
      var set = function (u, v) { var b = el.querySelector('[data-u="' + u + '"]'); if (b) b.textContent = pad(v); };
      set('d', dd); set('h', hh); set('m', mm); set('s', ss);
    };
    tick();
    cdTimers.set(el, setInterval(tick, 1000));
  }

  /* ---------- count-up numbers ---------- */
  function countUp(el) {
    var target = el.getAttribute('data-vb-count') || el.textContent;
    var m = target.match(/^([^\d]*)([\d,.]+)(.*)$/);
    if (!m) return;
    var num = parseFloat(m[2].replace(/,/g, '')), dec = (m[2].split('.')[1] || '').length, comma = m[2].indexOf(',') > -1;
    var t0 = null, dur = 1400;
    var fmt = function (v) { var s = v.toFixed(dec); if (comma) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); return m[1] + s + m[3]; };
    var step = function (ts) {
      if (!t0) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(num * e);
      if (k < 1) requestAnimationFrame(step); else el.textContent = target;
    };
    requestAnimationFrame(step);
  }
  var countIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (en) {
    en.forEach(function (x) { if (x.isIntersecting) { countIO.unobserve(x.target); countUp(x.target); } });
  }, { threshold: .4 }) : null;

  /* ---------- cart drawer ---------- */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents, fmt) {
    fmt = fmt || (d.querySelector('[data-money-format]') || {}).getAttribute && d.querySelector('[data-money-format]').getAttribute('data-money-format') || '£{{amount}}';
    cents = Math.round(+cents || 0);
    var dec2 = (cents / 100).toFixed(2), noDec = Math.round(cents / 100).toString();
    var withCommas = function (s) { var p = s.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return p.join('.'); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withCommas(noDec);
      if (k === 'amount_with_comma_separator') return dec2.replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return noDec;
      return withCommas(dec2);
    });
  }
  function isGift(it) { return it.properties && (it.properties._viby_gift || it.properties['_viby_gift']); }
  function cartRender(c) {
    d.querySelectorAll('[data-vb-cart-count]').forEach(function (n) {
      n.textContent = c.item_count;
      if (n.classList.contains('vb-cart__count')) n.classList.toggle('is-empty', !c.item_count);
    });
    var dr = d.querySelector('[data-vb-cart]');
    if (!dr) return;
    var list = dr.querySelector('[data-vb-cart-items]'), foot = dr.querySelector('[data-vb-cart-foot]');
    if (!c.items.length) {
      list.innerHTML = '<p class="vb-cart-drawer__empty">' + esc(dr.getAttribute('data-empty')) + '</p>';
      foot.hidden = true;
    } else {
      list.innerHTML = c.items.map(function (it) {
        var img = it.featured_image && it.featured_image.url ? it.featured_image.url : it.image;
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        var meta = [];
        if (it.variant_title && it.variant_title !== 'Default Title') meta.push(esc(it.variant_title));
        if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) meta.push(esc(it.selling_plan_allocation.selling_plan.name));
        var gift = isGift(it);
        return '<div class="vb-cline" data-key="' + esc(it.key) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="72" height="72">' : '<span></span>') +
          '<div><div class="vb-cline__t">' + esc(it.product_title) + '</div>' +
          (meta.length ? '<div class="vb-cline__m">' + meta.join(' · ') + '</div>' : '') +
          (gift ? '<span class="vb-cline__gift">Free gift</span>' :
            '<div class="vb-qty"><button type="button" data-vb-qty="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-vb-qty="1" aria-label="Increase quantity">+</button></div>') +
          '</div><div class="vb-cline__r"><div>' + (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s> ' : '') + money(it.final_line_price) + '</div>' +
          (gift ? '' : '<button type="button" class="vb-cline__x" data-vb-remove>Remove</button>') + '</div></div>';
      }).join('');
      foot.hidden = false;
      dr.querySelector('[data-vb-cart-total]').textContent = money(c.total_price);
    }
    var th = +dr.getAttribute('data-threshold') || 0, ship = dr.querySelector('[data-vb-cart-ship]');
    if (ship && th) {
      var left = th - c.total_price;
      ship.querySelector('[data-vb-cart-ship-text]').innerHTML = left > 0 ? 'You\'re <b>' + money(left) + '</b> away from free delivery' : '🎉 You\'ve unlocked <b>free delivery</b>';
      ship.querySelector('[data-vb-cart-ship-bar]').style.width = Math.min(100, c.total_price / th * 100) + '%';
    }
  }
  function cartFetch(url, body) {
    return fetch(ROOT.replace(/\/$/, '') + url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  var VibyCart = window.VibyCart = {
    money: money,
    refresh: function () { return cartFetch('/cart.js').then(function (c) { cartRender(c); return c; }); },
    open: function () {
      var dr = d.getElementById('VbCart');
      if (!dr) { window.location.href = ROOT + 'cart'; return; }
      drawer('VbCart', true);
      return VibyCart.refresh();
    },
    // after: 'drawer' (default), 'cart' or 'checkout'; replace: empty the cart first
    add: function (items, after, replace) {
      var start = replace ? cartFetch('/cart/clear.js', {}) : Promise.resolve();
      return start.then(function () { return cartFetch('/cart/add.js', { items: items }); }).then(function () {
        if (after === 'checkout') { window.location.href = ROOT + 'checkout'; return new Promise(function () {}); }
        if (after !== 'cart' && d.getElementById('VbCart')) return VibyCart.open();
        window.location.href = ROOT + 'cart';
      });
    },
    change: function (key, qty) {
      var dr = d.getElementById('VbCart'); if (dr) dr.classList.add('is-busy');
      return cartFetch('/cart/change.js', { id: key, quantity: qty }).then(function (c) {
        var paid = c.items.filter(function (i) { return !isGift(i); });
        if (!paid.length && c.items.length) {
          var up = {}; c.items.forEach(function (i) { up[i.key] = 0; });
          return cartFetch('/cart/update.js', { updates: up });
        }
        return c;
      }).then(function (c) { cartRender(c); return c; })
        .finally(function () { if (dr) dr.classList.remove('is-busy'); });
    }
  };

  /* ---------- init / re-init ---------- */
  function init(scope) {
    scope = scope || d;
    scope.querySelectorAll('[data-vb-ann]').forEach(annInit);
    scope.querySelectorAll('[data-vb-countdown]').forEach(cdInit);
    scope.querySelectorAll('[data-vb-count]').forEach(function (n) { if (countIO) countIO.observe(n); });
    scope.querySelectorAll('[data-vb-carousel]').forEach(carInit);
    scope.querySelectorAll('[data-vb-accordion] .vb-qa').forEach(function (q) {
      q.querySelector('.vb-qa__q').setAttribute('aria-expanded', q.classList.contains('is-open') ? 'true' : 'false');
    });
    scope.querySelectorAll('.vb-reel[data-autoplay="true"] video').forEach(function (v) {
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          var r = closest(x.target, '.vb-reel');
          if (r.classList.contains('is-playing')) return;
          if (x.isIntersecting) { x.target.muted = true; var p = x.target.play(); if (p && p.catch) p.catch(function () {}); } else x.target.pause();
        });
      }, { threshold: .6 });
      io.observe(v);
    });
    onScroll();
    stickyCta();
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('load', function () { d.querySelectorAll('[data-vb-carousel]').forEach(carState); });

  /* ---------- Shopify theme editor ---------- */
  d.addEventListener('shopify:section:load', function (e) { lock(false); init(e.target); });
  d.addEventListener('shopify:section:unload', function () { lock(false); });
  d.addEventListener('shopify:block:select', function (e) {
    var b = e.target;
    var qa = closest(b, '.vb-qa') || (b.classList && b.classList.contains('vb-qa') ? b : null);
    if (qa) qaToggle(qa, true);
    var track = closest(b, '[data-vb-track]');
    if (track) track.scrollTo({ left: b.offsetLeft - track.offsetLeft - 20, behavior: 'smooth' });
    var msg = b.classList && b.classList.contains('vb-ann__msg') ? b : null;
    if (msg) {
      var root = closest(msg, '[data-vb-ann]');
      root.querySelectorAll('.vb-ann__msg').forEach(function (m) { m.classList.toggle('is-active', m === msg); });
      if (annTimers.has(root)) clearInterval(annTimers.get(root));
    }
    var dr = closest(b, '.vb-drawer');
    if (dr) drawer(dr.id, true);
  });
  d.addEventListener('shopify:block:deselect', function (e) {
    var root = closest(e.target, '[data-vb-ann]');
    if (root) annInit(root);
  });
  d.addEventListener('shopify:section:select', function (e) {
    var h = e.target.querySelector && e.target.querySelector('[data-vb-header]');
    if (h) (closest(h, '.shopify-section') || h).classList.remove('is-hidden');
  });
})();
